import { IPrescription, ISymptom } from "@curefit/care-common";
import { IPastPsychiatricHistory, IPatientAllergy, IPatientSystemReview } from "@curefit/ehr-common";
import { PatientPersonalProfile } from "@curefit/ups-common";
import * as _ from "lodash";
import * as React from "react";
import GenericEditViewCont from "../../containers/EditView/GenericEditViewCont";
import ErrorContainer from "../../containers/ErrorContainer";
import IChiefComplaint from "../../models/IChiefComplaint";
import IDoctorProfile from "../../models/IDoctorProfile";
import IEditedBy from "../../models/IEditedBy";
import IModal from "../../models/IModal";
import { IPatientVitalResponse } from "../../models/IPatientVitalResponse";
import { ITypeFormResponse } from "../../models/ITypeFormResponse";
import ModelFactory from "../../models/ModelFactory";
import { IEHRSavePatientMedicalProfile } from "../../models/patients/IEHRSavePatientMedicalProfile";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import { AppMessages, ConfigConstants, SymptomTypes, TabNames } from "../../utils/AppConstants";
import AppUtils from "../../utils/AppUtils";
import removeQ from "../../utils/DataUtils";
import { EditViewDisplayMode } from "../common/EditViewCard";
import PatientVitalsSummaryBar from "../patient/summary-bar/PatientVitalsSummaryBar";


export interface PatientChiefComplaintsTabProps {
    appointmentId: number,
    editedBy: IEditedBy,
    patientId: number,
    patientAllergies?: IPatientAllergy[],
    patientVitals: IPatientVitalResponse[],
    patientChiefComplaints: ISymptom[],
    saveEditedChiefComplaints: (chiefComplaint: ISymptom[]) => void,
    savePatientSymptoms: (patientId: number, patientMedicalProfile: any) => any,
    fetchStaticSymptomsData: (input: string) => Promise<any>,
    nextTab: () => void,
    staticReviewSystemsData: IStaticDataValue[],
    saveReviewOfSystemsData: (data: IPatientSystemReview[]) => void,
    reviewOfSystemsData: IPatientSystemReview[],
    doctorType: string,
    saveEditedPrescription: (prescription: IPrescription) => void,
    prescription: IPrescription,
    appointmentSchedule: any,
    currentMedicalProfile: IEHRSavePatientMedicalProfile,
    savePatientMedicalProfile: (patientId: number, patientMedicalProfile: any, appointmentId: number, doctorType: string) => Promise<any>,
    saveEditedMedicalProfile: (patientMedicalProfile: IEHRSavePatientMedicalProfile) => void,
    patientPersonalProfile: PatientPersonalProfile,
    saveEditedPatientProfile: (patientPersonalProfile: PatientPersonalProfile) => void,
    updatePatientProfileData: (id: number, profile: PatientPersonalProfile) => Promise<any>,
    personalProfileId: number | string,
    patientTypeFormData: ITypeFormResponse;
    typeFormMapping: any;
    pastPsychiatricHistoryList: IPastPsychiatricHistory[],
    isSelf: boolean,
    curefitUserId: number,
    uiConfiguration: any[],
    doctorProfile: IDoctorProfile;
    hideReasonForVisit?: boolean;
    reasonForVisit?: string,
    fetchPatientPastSessions: (patientId: number, subSectionKey: string) => Promise<any>;
    addSymptomForReview: (name: string) => Promise<any>;
    responseData: IModal;
    modalResponse: IModal;
    responseStatus: any;
    suggestions: {[key: string]: any}

}

export interface PatientChiefComplaintsTabState {
    error?: string,
    errorDetails?: string,
    tabWidgets: any,
    isSaving?: boolean,
}

type Props = PatientChiefComplaintsTabProps

class PatientChiefComplaintsTab extends React.Component<Props, PatientChiefComplaintsTabState> {
    constructor(props: Props) {
        super(props);
        this.state = {
            error: null,
            errorDetails: null,
            tabWidgets: this.props.uiConfiguration.filter((widget) => widget.sectionKey === TabNames.CHIEF_COMPLAINTS),
            isSaving: false,
        }
    }

    componentWillUnmount() {
        this.saveEditedPatientComplaints();
    }

    saveEditedPatientComplaints() {
        let patientMedicalProfile: any = {
          ...this.props.currentMedicalProfile
        };
        this.state.tabWidgets.map((widgetData: any) => {
            if (patientMedicalProfile[ConfigConstants.NEWCONFIGDATA])
                patientMedicalProfile[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey] = (this as any | PatientChiefComplaintsTab)[widgetData.subSectionKey].getSaveObject();
        })
        this.props.saveEditedMedicalProfile(patientMedicalProfile);
    }

    getPatientChiefComplaintsObject() {
        let complaintsObject: any = {};
        complaintsObject[ConfigConstants.NEWCONFIGDATA] = {};
        this.state.tabWidgets.map((widgetData: any) => {
            complaintsObject[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey] = (this as any | PatientChiefComplaintsTab)[widgetData.subSectionKey].getSaveObject();
            this.getFormattedObject(widgetData, complaintsObject);
        })
        return complaintsObject;
    }

    getFormattedObject = (widgetData: any, complaintsObject: any) => {
        let chiefComplaintsData: any = complaintsObject[ConfigConstants.NEWCONFIGDATA][widgetData.subSectionKey];
        let chiefComplaintObj = Object.values(chiefComplaintsData);
        chiefComplaintObj.forEach((res: any) => {
            if (Array.isArray(res)) removeQ(res);
        })
        chiefComplaintsData.patientComplaints && Array.isArray(chiefComplaintsData.patientComplaints) && chiefComplaintsData.patientComplaints.map((data: any) => {
            data ? data.type = SymptomTypes.CHIEF : "";
        })
    }

    savePatientComplaints = () => {
        let patientMedicalProfile = this.getPatientChiefComplaintsObject();
        this.saveEditedPatientComplaints();
        if (this.validateChiefComplaints()) {
            this.setState({ isSaving: true, error: null });
            this.props.savePatientMedicalProfile(this.props.patientId, patientMedicalProfile, this.props.appointmentId, this.props.doctorType).then(() => {
                this.props.nextTab();
            }).catch(err => {
                this.setState({
                    error: AppMessages.CHIEF_COMPLAINTS_SAVE_ERROR,
                    errorDetails: err.message,
                    isSaving: false
                })
            });
        }
    }

    validateChiefComplaints = (): boolean => {
        let status = true;
        let symptoms: any = {};
        this.state.tabWidgets.map((widgetData: any) => {
            symptoms[widgetData.subSectionKey] = (this as any | PatientChiefComplaintsTab)[widgetData.subSectionKey].isFormDirty();
        })
        let isDirty = Object.values(symptoms).findIndex(obj => obj === true) > -1;
        if (isDirty) {
            this.state.tabWidgets.map((widgetData: any, index: number) => {
                if (symptoms[widgetData.subSectionKey]) {
                    this.invalidItemError(widgetData.subSectionTitle);
                }
            })
            status = false;
        }
        return status;
    };

    createChiefComplaintObjFromSymptoms = (): Partial<IChiefComplaint> => {
        let chiefComplaint = ModelFactory.createNewChiefComplaint();
        let currentSymptoms = this.props.patientChiefComplaints;
        if (!_.isEmpty(currentSymptoms)) {
            chiefComplaint.complaints = currentSymptoms
        } else {
            chiefComplaint.complaints = [];
        }
        return chiefComplaint;
    }

    clearErrorMessage = () => {
        this.setState({
            error: null,
            errorDetails: null
        })
    }

    invalidItemError = (section: string) => {
        this.setState({
            error: AppMessages.CHIEF_COMPLAINTS_VALIDATION_ERROR,
            errorDetails: `Error in ${section}. Please Review the form and proceed.`
        })
    };


    render() {
        let errorMessage = !_.isNull(this.state.error) ? this.state.error : AppMessages.CHIEF_COMPLAINTS_SAVE_ERROR;
        let errorDetails = !_.isNull(this.state.errorDetails) ? this.state.errorDetails : "";
        let symptoms: any[] = [];
        this.props.currentMedicalProfile.currentConsultationData.chiefComplaints && this.props.currentMedicalProfile.currentConsultationData.chiefComplaints.patientComplaints && this.props.currentMedicalProfile.currentConsultationData.chiefComplaints.patientComplaints.forEach((data: any) => {
           if(data.complaint && data.complaint.displayValue) {
               symptoms.push(data.complaint.displayValue)
           }
        })

        if (this.props.modalResponse
            && !this.props.modalResponse.status
            && this.props.modalResponse.modalUIConfig
            && this.props.modalResponse.modalUIConfig.modalData
            && symptoms.includes(this.props.modalResponse.modalUIConfig.modalData)) {
            let prevSelections = symptoms;
            let index = prevSelections.indexOf(this.props.modalResponse.modalUIConfig.modalData);
            prevSelections.splice(index, 1);
            symptoms = prevSelections;
        }
        return (
            <div className="chief-complaints-tab-container">
                {
                    !_.isNull(this.state.error) &&
                    <ErrorContainer errorText={errorMessage} errorDetails={errorDetails} errorCode={0}
                        closeError={this.clearErrorMessage}
                        reportError={true} rollbarPayload={{
                            message: errorMessage,
                            errorDetails: errorDetails,
                            request: this.getPatientChiefComplaintsObject()
                        }} />
                }
                <div className={"sub-container"}>
                    <PatientVitalsSummaryBar patientVitals={this.props.patientVitals}
                        patientAllergies={this.props.patientAllergies} />
                </div>

                {this.state.tabWidgets.map((widgetData: any, index: number) => {
                    let tabData = AppUtils.consultationDataDecider(this.props.currentMedicalProfile, true, widgetData.subSectionKey);

                    tabData = {
                        ...tabData,
                        complaints: symptoms
                    }

                    return <div key={widgetData.subSectionKey} className="patient-info-subsection concern-section">
                        <GenericEditViewCont
                            appointmentId={this.props.appointmentId}
                            patientId={this.props.patientId}
                            ref={(chiefComplaintsDOM) => { (this as any | PatientChiefComplaintsTab)[widgetData.subSectionKey] = chiefComplaintsDOM }}
                            displayMode={EditViewDisplayMode.EDIT} widgetData={widgetData} tabData={tabData}
                            fetchPatientPastSessions={this.props.fetchPatientPastSessions} addSymptomForReview={this.props.addSymptomForReview}
                            responseStatus={this.props.responseStatus} modalResponse={this.props.modalResponse}
                        />
                    </div>
                })}
                <div className={"save-button collapsible-card"}>
                    <input className="card-primary-action" type="button" value="Save"
                        onClick={this.savePatientComplaints} />
                </div>
            </div>
        );
    }
}

export default PatientChiefComplaintsTab